import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {ModalController, ToastController} from '@ionic/angular';
import {SelfEvaluationRecord} from '../../../../../self-evaluation/_interfaces/self-evaluation-record.interface';
import {BaseClass} from '../../../../classes/base';
import {QuestionConfig} from '../../../../interfaces/process-config.interface';
import {TranslationService} from '../../../../services/translation.service';
import {UtilService} from '../../../../services/util.service';

@Component({
    selector: 'app-text-questions',
    templateUrl: './text-questions.component.html',
    styleUrls: ['./text-questions.component.scss', '../../question-types.component.scss'],
})
export class TextQuestionsComponent extends BaseClass implements OnInit {

    @Input() question: QuestionConfig;
    @Input() formGroup: UntypedFormGroup;
    @Input() isManagerComment: boolean = false;
    @Input() evaluation?: SelfEvaluationRecord = null;
    @Input() managerAnswer: boolean = false;
    @Input() showRequiredBadge: (formGroup: UntypedFormGroup, index: number) => boolean;
    @Input() getQuestionAnswer: (question: QuestionConfig, gIndex?: number) => boolean;

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        private _modalController: ModalController,
        private _utilService: UtilService,
    ) {
        super(_toastController, _translationService);
    }

    ngOnInit() {
    }

    public separateAnswers(str: string) {
        const temp = str.trim().split(new RegExp('[\n]', 'g'));
        temp.forEach((element, index) => {
            if (element === '' || element === ' ') {
                temp.splice(index, 1);
            }
        });
        return temp;
    }

}
